import { memo } from "react";

import { cn } from "@/lib/chillnn/cn";

import type { DayOfWeekArrayType } from "../../root/use-initialize/utils/types";

type Props = {
	dayOfWeekArray: DayOfWeekArrayType;
};

export const HeaderDayOfWeek = memo(({ dayOfWeekArray }: Props) => {
	return (
		<div className="grid grid-cols-7 place-items-center gap-y-0.5">
			{dayOfWeekArray.map((dayOfWeek, idx) => {
				const isSunday = dayOfWeek === "日" || dayOfWeek === "Su";
				const isSaturday = dayOfWeek === "土" || dayOfWeek === "Sa";

				return (
					<h6
						className={cn(
							"select-none text-sm", //
							isSunday && "text-pink-400",
							isSaturday && "text-blue-400",
						)}
						key={idx}
					>
						{dayOfWeek}
					</h6>
				);
			})}
		</div>
	);
});

HeaderDayOfWeek.displayName = "HeaderDayOfWeek";
